module.exports = __webpack_public_path__ + "img/7.fcf35fad.png";